const AcademicDetails = () => {
    return (
        <div id="top" className="vision-card">
            <h3>ACADEMIC DETAILS</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <thead>
                        <tr>
                            <th colSpan="2">
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "flex-start",
                                        flexWrap: "wrap",
                                        width: "100%",
                                    }}
                                >
                                    <span>ACADEMIC DETAILS</span>

                                    <div style={{ textAlign: "right" }}>
                                        <div>09308-N J MISSION SCHOOL KASIA KUSHINAGAR UP</div>
                                        <div>Date: 15-12-2016</div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <br />
                        <tr>
                            <th>SUBJECTS OFFERED FOR CLASS 10</th>
                            <th>SUBJECTS OFFERED FOR CLASS 12</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>
                                002--HINDI COURSE-A <br />
                                041--MATHEMATICS <br />
                                086--SCIENCE <br />
                                087--SOCIAL SCIENCE <br />
                                101--ENGLISH COMM.
                            </td>

                            <td>
                                030--ECONOMICS <br />
                                041--MATHEMATICS <br />
                                042--PHYSICS <br />
                                043--CHEMISTRY <br />
                                044--BIOLOGY <br />
                                048--PHYSICAL EDUCATION <br />
                                054--BUSINESS STUDIES <br />
                                055--ACCOUNTANCY <br />
                                083--COMPUTER SCIENCE <br />
                                301--ENGLISH CORE <br />
                                302--HINDI CORE <br />
                                500--WORK EXPERIENCE <br />
                                501--PHY & HEALTH EDUCATION
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AcademicDetails;